import { render, staticRenderFns } from "./addCase.vue?vue&type=template&id=1a737f10"
import script from "./addCase.vue?vue&type=script&lang=js"
export * from "./addCase.vue?vue&type=script&lang=js"
import style0 from "./addCase.vue?vue&type=style&index=0&id=1a737f10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports